import React from "react";
import PropTypes from "prop-types";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";
import TopAppBar from "../common_components/app_bar_options.component";
import BottomBar from "../common_components/bottom_bar_options.component";
import IconButton from "@material-ui/core/IconButton";
import EditIcon from "@material-ui/icons/Edit";
import CircularProgress from "@material-ui/core/CircularProgress";
import Snackbar from "@material-ui/core/Snackbar";
import axiosConfig from "../axiosConfig";
import requireSub from "../common_components/requireAuthorized";
import logo from "../../assets/img/cw_logo.png";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    boxShadow: 3,
    "@media (min-width:100px)": {
      marginLeft: theme.spacing(10),
    },
    "@media (min-width:875px)": {
      marginLeft: theme.spacing(10),
    },
    "@media (min-width:1000px)": {
      marginLeft: theme.spacing(30),
    },
  },
  bottom_grid: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    boxShadow: 3,
  },
  image_grid: {
    "@media (min-width:100px)": {
      marginLeft: theme.spacing(15),
      marginTop: theme.spacing(10),
    },
    "@media (min-width:875px)": {
      marginLeft: theme.spacing(20),
      marginTop: theme.spacing(20),
    },
    "@media (min-width:1000px)": {
      marginLeft: theme.spacing(25),
      marginTop: theme.spacing(30),
    },
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  text_title: {
    fontSize: "3rem",
    fontFamily: "Open Sans",
    fontWeight: "300",
    "@media (min-width:200px)": {
      fontSize: "1.5rem",
    },
    "@media (min-width:600px)": {
      fontSize: "2rem",
    },
    "@media (min-width:960px)": {
      fontSize: "3rem",
    },
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
    textAlign: "right",
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    backgroundColor: "#FFF",
    width: "8%",
    height: 40,
    borderColor: "#F6277F",
    borderWidth: 40,
  },
  notchedOutline: {
    borderWidth: "1px",
    borderColor: "#000 !important",
  },
  signin_text: {
    color: "#F6277F",
    fontFamily: "Open Sans",
  },
  enter_text: {
    color: "#FFF",
    fontWeight: "600",
    fontFamily: "Open Sans",
    fontSize: 14,
    textTransform: "none",
  },
  hide_input: {
    width: "0.1px",
    height: "0.1px",
    opacity: 0,
    overflow: "hidden",
    position: "absolute",
    zIndex: "-1",
  },
  image_button: {
    cursor: "pointer",
  },
  input: {
    minHeight: 300,
    "@media (min-width:500px)": {
      width: 400,
    },
    "@media (min-width:960px)": {
      width: 500,
    },
    "@media (min-width:1100px)": {
      width: 900,
    },
  },
  progress_color: {
    color: "#FFF",
  },
});

class AboutBrand extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      redirect: false,
      data: null,
      fullscreen: false,
      loading: false,
      readOnly: true,
      open: false,
      vertical: "top",
      horizontal: "center",
      img_data:
        "https://www.indiaspora.org/wp-content/uploads/2018/10/image-not-available.jpg",
      image: null,
      about: "",
    };
    this.submitForm = this.submitForm.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    let brand_id = sessionStorage.getItem("brand_id");
    if (!brand_id) {
      this.props.history.push("/login");
    } else {
      try {
        // console.log("BRAND IS ID- ", brand_id);
        axiosConfig
          .get(`/brand/${brand_id}`)
          .then((product_response) => {
            // console.log("BRAND IS: ", product_response);
            this.loadData(product_response.data);
          })
          .catch((err) => {
            // console.log(err);
            alert("Unexpected Error");
          });
      } catch (err) {
        // console.log(err);
      }
    }
  }

  componentWillMount() {
    document.title = "About Brand | CanaWho";
  }

  loadData(product_response) {
    this.setState({ loading: true });
    // console.log(product_response);
    this.setState({
      img_data: product_response.logo
        ? product_response.logo
        : "https://www.indiaspora.org/wp-content/uploads/2018/10/image-not-available.jpg",
      about: product_response.about ? product_response.about : "",
      loading: false,
    });
  }

  submitForm() {
    let that = this;
    let brand_id = sessionStorage.getItem("brand_id");
    const { about, image } = that.state;

    that.setState({ loading: true });
    if (image instanceof File) {
      const formData = new FormData();
      formData.append("image", image, image.name);
      axiosConfig
        .post("/upload", formData)
        .then((response) => {
          // console.log(response.data.fileUrl);
          axiosConfig
            .put(`/brand/${brand_id}`, {
              about: about,
              logo: response.data.fileUrl,
            })
            .then((product_response) => {
              // console.log("Change IS: ", product_response);
              that.setState({ loading: false });
              alert("New Info Saved");
            })
            .catch((err) => {
              // console.log(err);
              // console.log(err.response);
              that.setState({ loading: false });
              alert("Unexpected Error");
            });
        })
        .catch((err) => {
          that.setState({ loading: false });
          alert("Unexpected Error");
          // console.log(err);
          // console.log(err.response);
        });
    } else {
      axiosConfig
        .put(`/brand/${brand_id}`, { about: about })
        .then((product_response) => {
          // console.log("Change IS: ", product_response);
          that.setState({ loading: false });
          alert("New Info Saved");
        })
        .catch((err) => {
          // console.log(err);
          // console.log(err.response);
          that.setState({ loading: false });
          alert("Unexpected Error");
        });
    }
  }

  handleFileChange(event) {
    const { target } = event;
    const { files } = target;

    if (files && files[0]) {
      var reader = new FileReader();

      reader.onloadstart = () => this.setState({ loading: true });

      let file = event.target.files[0];

      reader.onload = (event) => {
        this.setState({
          img_data: event.target.result,
          image: file,
          loading: false,
        });
      };

      reader.readAsDataURL(file);
    }
  }

  addDefaultSrc(ev) {
    ev.target.src =
      "https://image.shutterstock.com/image-vector/black-linear-photo-camera-logo-260nw-622639151.jpg";
  }

  handleClick = (newState) => () => {
    this.setState({ open: true, ...newState });
  };

  handleClose = () => {
    this.setState({ ...this.state, open: false });
  };

  render() {
    const { classes } = this.props;
    const {
      img_data,
      about,
      loading,
      readOnly,
      vertical,
      horizontal,
      open,
    } = this.state;

    return (
      <div className={classes.root}>
        <TopAppBar />
        <Grid container direction="column" justify="center">
          <Grid container direction="row">
            <Grid item xs={10}>
              <div className={classes.paper}>
                <Typography
                  component="h1"
                  variant="h4"
                  style={{ color: "#F6277F", fontFamily: "Open Sans" }}
                >
                  BRAND INFORMATION
                </Typography>
                <Typography
                  variant="h6"
                  style={{
                    color: "#000",
                    fontFamily: "Open Sans",
                    marginTop: "8%",
                  }}
                >
                  About Brand
                </Typography>
                <Grid
                  item
                  xs={12}
                  container
                  spacing={0}
                  direction="row"
                  alignItems="center"
                  justify="center"
                >
                  <Grid item>
                    <form className={classes.form} noValidate>
                      <TextField
                        variant="outlined"
                        margin="normal"
                        fullWidth
                        id="about"
                        label="About your brand"
                        name="about"
                        autoComplete="section-about"
                        multiline
                        value={about}
                        onChange={(text) => {
                          this.setState({ about: text.target.value });
                        }}
                        InputLabelProps={{ style: { color: "grey" } }}
                        InputProps={{
                          classes: { notchedOutline: classes.notchedOutline },
                          className: classes.input,
                          readOnly: Boolean(readOnly),
                          disabled: Boolean(readOnly),
                        }}
                      />
                    </form>
                  </Grid>
                  <Grid item>
                    <IconButton
                      variant="contained"
                      component="label"
                      style={{ backgroundColor: "#F6227F", marginLeft: 20 }}
                      onClick={() => this.setState({ readOnly: false })}
                    >
                      <EditIcon fontSize="small" style={{ color: "#FFF" }} />
                    </IconButton>
                  </Grid>
                </Grid>
              </div>
            </Grid>
            <Grid
              item
              xs={12}
              container
              spacing={0}
              direction="row"
              alignItems="center"
              justify="center"
            >
              {/* <div class="circular--landscape"> */}
              {loading ? (
                <CircularProgress size={25} />
              ) : (
                <img
                  alt="Not Available"
                  src={img_data}
                  style={{
                    borderRadius: "50%",
                    height: 200,
                    width: 200,
                    objectFit: "fill",
                    border: "5px solid #555",
                  }}
                />
              )}
              {/* </div> */}
              <IconButton variant="contained" component="label">
                <EditIcon fontSize="small" style={{ color: "#F6227F" }} />
                <input
                  id="brand_pic"
                  name="brand_pic"
                  type="file"
                  accept="image/*"
                  onChange={this.handleFileChange}
                  className={classes.hide_input}
                  style={{ display: "none" }}
                />
              </IconButton>
            </Grid>
          </Grid>
          <div className={classes.bottom_grid}>
            <Button
              fullWidth
              variant="contained"
              style={{ backgroundColor: "#F6277F", boxShadow: "2" }}
              className={classes.submit}
              onClick={() => {
                this.submitForm();
                this.handleClick({ vertical: "bottom", horizontal: "center" });
              }}
            >
              {loading ? (
                <CircularProgress
                  className={classes.progress_color}
                  size={25}
                />
              ) : (
                <Typography variant="h7" className={classes.enter_text}>
                  Save
                </Typography>
              )}
            </Button>
            <Grid>
              <img
                alt=""
                style={{ padding: 10, marginTop: 16, height: 50 }}
                src={logo}
              />
            </Grid>
          </div>
          <Snackbar
            anchorOrigin={{ vertical, horizontal }}
            key={`${vertical},${horizontal}`}
            open={open}
            onClose={this.handleClose}
            ContentProps={{
              "aria-describedby": "message-id",
            }}
            message={<span id="message-id">Information Saved</span>}
          />
        </Grid>
        <BottomBar />
      </div>
    );
  }
}

AboutBrand.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default requireSub(withStyles(styles)(AboutBrand));
